import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import LavorisService from "../../../services/LavorisService";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import StyledWrapper from "./style";
import Textarea from "../../../components/others/Textarea/Textarea";
import { PatientBasicInfo } from "../../../components/others/PatientBasicInfo";
import { RootState } from "../../../store/combineReducer";
import { GetOneAppointmentResponseService, } from "../../../services/TurnServices/Turns.type";
import { useFetchOne, useModal } from "../../../hooks";
import { EditTurnType } from "./types";
import { getAppointmentToUpdateInfo } from "./utils";
import { SuccessModal } from "../../../components/others/SuccessModal";
import { SelectedFiles } from "../../../components/others/FileUploader/FileUploader.types";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";
import DownloadButton from "../../../components/others/DownloadButton/downloadButton";
import { Modal } from "../../../components/others/Modal";


const SUCCESS = "successEdition";

type TProps = {
    toggleModal: boolean;
    urlTittle: string;
    refreshFunction?: Function;
    isApplicant?: boolean;
    patient?: any
    onClose?: Function;

};

export default function EditPrestadorTurn({
    toggleModal,
    urlTittle,
    refreshFunction,
    patient,
    onClose,
    isApplicant }: TProps) {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        watch,
        resetField,
        setValue,
        reset: resetForm,
    } = useForm<EditTurnType>({
        mode: "all",
    });
    const styles = "text-2xl text-red-500 font-bold";
    const { closeModal, isActive, openModal } = useModal();
    const { showAlert } = useAlert();
    const [successMessages, setSuccessMessages] = useState({
        title: "",
        subTitle: "",
    });

    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(
        null,
    );
    const afterFetch = (appointment: GetOneAppointmentResponseService) => {
        resetForm(getAppointmentToUpdateInfo(appointment), {
            keepDefaultValues: true,
        });
    };

    const appointment = useFetchOne<GetOneAppointmentResponseService>(
        "appointments",
        searchParams.get("rowId"),
        afterFetch,
    );

    const LavorisInstance = LavorisService.getInstance();
    const id = searchParams.get("rowId");
    const onSubmit = async (data: EditTurnType) => {
        setIsLoading(true);
        try {
            if (!id) return console.log("Falta el id del turno");

            const partialSubmitData = { observations: data.comments };
            await LavorisInstance.TurnServices.UpdatePrestadorAppRequest(partialSubmitData, id,)

            const filesToUpload = selectedFiles?.profileImages ?? [];
            if (filesToUpload.length > 0) {
                await Promise.all(filesToUpload.map((file) => uploadFile(id, file)));
            }

            setSuccessMessages({
                title: "La edición se solicitó con éxito.",
                subTitle: "En las próximas horas se te informará la fecha y hora de turno.",
            });
            openModal(SUCCESS);
            refreshFunction?.();

        } catch (err: any) {
            console.log(err)
            showAlert(getErrorMessage({ title: 'No se pudo realizar la edición del turno.', err }))
        } finally {
            setIsLoading(false);
        }
    };

    ///Funciones para la carga de archivos
    const updateUploadedFiles = (files: File[]) => setSelectedFiles({ ...selectedFiles, profileImages: files });

    const uploadFile = async (appointmentId: string, selectedFile: File) => {
        await LavorisInstance.TurnServices.addFile(
            { file: selectedFile },
            appointmentId,
        ).catch((e: any) => console.log(e));
    };



    if (!appointment)
        return (
            <Modal
                show={toggleModal}
                modalTitle={"Editar solicitud de Turno en Clínica Externa"}
                titleStyle={styles}
                urlTittle={urlTittle}
            >
                <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
                    {" "}
                    Cargando...{" "}
                </h1>
            </Modal>

        );

    return (
        <Modal
            show={toggleModal}
            modalTitle={"Editar solicitud de Turno en Clínica Externa"}
            titleStyle={styles}
            urlTittle={urlTittle}
        >
            <div className="max-w-3xl ">
                <PatientBasicInfo patient={appointment?.patient} />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <StyledWrapper.FormContainer>
                        <div className="flex flex-col gap-1 justify-center align-middle">
                            <label className="text-center text-xl text-red-600">INFORMACIÓN OBLIGATORIA</label>
                            <ul className="list-disc pl-6">
                                <li>Ubicación actual del empleado o postulante (ciudad, localidad y provincia)</li>
                                <li>Examen Ingreso, prácticas (postulantes)</li>
                                <li>Examen Periódico o Egreso, prácticas (empleados)</li>
                            </ul>
                        </div>
                        <Textarea
                            fieldName="comments"
                            label="Comentarios"
                            register={register}
                            error={errors?.comments}
                            styles="rounded w-full"
                            rows={8}
                            required
                        />
                        <StyledWrapper.ListItem>Adjunto:</StyledWrapper.ListItem>
                        {/* <span> {downloadButton}</span> */}
                        <DownloadButton id={id} updateUploadedFiles={updateUploadedFiles} />

                    </StyledWrapper.FormContainer>
                    <StyledWrapper.Footer>
                        <div className="w-52">
                            <PrimaryButton
                                type={"submit"}
                                text={"Editar Turno"}
                                styles="bg-red-500 font-bold text-white"
                                disabled={isLoading}
                            />
                        </div>
                    </StyledWrapper.Footer>
                </form>

                {isActive(SUCCESS) && (
                    <SuccessModal
                        show
                        urlTittle={SUCCESS}
                        modalTitle={successMessages.title}
                        modalSubtitle={successMessages.subTitle}
                        onClose={() => {
                            closeModal(SUCCESS);
                            closeModal("modalEditTurn");
                            closeModal("modalEditPrestadorTurn");
                            refreshFunction?.();
                        }}
                    />
                )}
            </div>
        </Modal>
    );
}
